export const PORTAL_SERVER = "https://portal.textaspect.com";